module.exports = __webpack_public_path__ + "static/media/ins.4a2361ea.svg";